export const uk = {
    '0-17': 'младше 18',
    '18-24': '18-24',
    '25-34': '25-34',
    '35-44': '35-44',
    '45-54': '45-54',
    '55-': 'старше 55',
    'all-ages': 'всех возрастов',
    'all-cpm-banner': 'Все баннеры',
    'all-genders': 'Мужчины и женщины',
    'all-items': 'Все',
    'all-mobile': 'Все смартфоны',
    android: 'Android',
    cancel: 'Отмена',
    'closed-panel-description':
        'Корректировки ставок позволяют повысить или понизить ставку в зависимости от характеристик пользователя, формата объявления и даже фактической погоды.',
    'cpm-banners': 'Баннеры',
    'demography-tab': 'Пол и возраст',
    desktops: 'Десктопы',
    'device-tab': 'Устройства',
    female: 'Женщины',
    inbanner: 'Видео в баннере',
    inpage: 'В текстовом контенте',
    'instream-web': 'В потоковом видео',
    interstitial: 'В приложениях',
    inventory: 'Видео',
    'inventory-tab': 'Инвентарь',
    ios: 'iOS',
    male: 'Мужчины',
    mobile: 'Смартфоны',
    'more-info-link': 'Подробнее',
    'no-value': 'Задайте корректировки ставок, чтобы получить больше трафика',
    'opened-panel-description':
        'Ставку можно повысить или понизить с помощью коэффициентов. Коэффициент — это заданная в процентах величина, на которую изменяется ставка. Если корректировок несколько, они применяются последовательно. {moreInfoLink}',
    'panel-description':
        'Ставку можно повысить или понизить с помощью коэффициентов. Коэффициент — это заданная в процентах величина, на которую изменяется ставка. Если корректировок несколько, они применяются последовательно. {moreInfoLink}',
    ready: 'Готово',
    'retargeting-tab': 'Целевая аудитория',
    rewarded: 'Видео за вознаграждение',
    'smart-banners-tab': 'Смарт-объявления',
    title: 'Корректировки ставок',
    'traffic-jam-tab': 'Пробки',
    'video-addition-tab': 'Видеодополнения',
    'weather-tab': 'Погода'
};
